import React from 'react'
import { BoxContainer } from '../../components'

import { Container, Icon } from './styles'

const BoxDash = ({ data }) => {
  if (data) {
    return (
      <Container>
        <BoxContainer>
          <header>
            <h2>{data.title}</h2>
          </header>

          <div>{`${data.startDate} à ${data.endDate}`}</div>

          <footer>
            <strong>{data.quantity}</strong>
            <div>
              <span>{data.percent}</span>
              <Icon up={data.up} />
            </div>
          </footer>
        </BoxContainer>
      </Container>
    )
  } else {
    return <div>****</div>
  }
}

export default BoxDash
